// Corporate Light Theme Constants
export const corporateTheme = {
  // Primary Colors - Darker for better readability
  primary: '#1e40af',      // Darker professional blue
  primaryDark: '#1e3a8a',  // Even darker blue
  primaryLight: '#2563eb', // Medium blue
  
  // Background Colors
  background: '#ffffff',            // Pure white
  backgroundSecondary: '#f8fafc',   // Light gray
  backgroundTertiary: '#f1f5f9',    // Slightly darker gray
  
  // Text Colors - Much darker for readability
  textPrimary: '#0f172a',          // Very dark gray (almost black)
  textSecondary: '#334155',        // Dark gray
  textTertiary: '#64748b',         // Medium gray
  
  // Card & Component Colors
  cardBackground: 'rgba(248, 250, 252, 0.8)',
  cardBorder: 'rgba(203, 213, 225, 0.8)',
  cardShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  
  // Button Colors
  buttonPrimary: '#1e40af',
  buttonPrimaryHover: '#1e3a8a',
  buttonSecondary: '#f1f5f9',
  buttonSecondaryHover: '#e2e8f0',
  
  // Accent Colors - Darker shades
  accent: '#1d4ed8',
  accentLight: '#3b82f6',
  success: '#059669',
  warning: '#d97706',
  error: '#dc2626',
  
  // Chart Colors - Much darker for visibility
  chartColors: {
    primary: '#1e40af',
    secondary: '#059669',
    tertiary: '#dc2626',
    quaternary: '#d97706',
    quinary: '#7c3aed',
    senary: '#0891b2'
  },
  
  // Gradients - Darker versions
  primaryGradient: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)',
  backgroundGradient: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
  
  // Typography
  fontFamily: '"Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  
  // Spacing
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem'
  },
  
  // Border Radius
  borderRadius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem'
  }
};

// Professional Corporate Labels (NO EMOJIS)
export const corporateLabels = {
  // Business process labels
  highConverting: 'HIGH-CONVERTING',
  premiumOffers: 'PREMIUM OFFERS',
  professionalSupport: 'PROFESSIONAL SUPPORT',
  
  // Service labels
  affiliate: 'AFFILIATE',
  marketing: 'MARKETING',
  revenue: 'REVENUE',
  commissions: 'COMMISSIONS',
  
  // Action labels
  startEarning: 'START EARNING',
  viewRates: 'VIEW RATES',
  getStarted: 'GET STARTED',
  consultExpert: 'CONSULT EXPERT',
  
  // Geographic labels
  eastAsia: 'EAST ASIA',
  global: 'GLOBAL',
  
  // Support labels
  support: 'SUPPORT',
  expert: 'EXPERT',
  consultation: 'CONSULTATION'
}; 